import React from 'react'

import './grided-row.scss'

const createStyles = ({ columns }) => ({
  gridTemplateColumns: `repeat(${columns}, 1fr)`,
})

const GridedRow = ({ columns = 1, children, ...rest }) => (
  <div className="grided-row" style={createStyles({ columns })} {...rest}>
    {children}
  </div>
)

export default GridedRow



// WEBPACK FOOTER //
// ./src/components/common/GridedRow/GridedRow.js